import EventEmitter from './EventEmitter.js'
import UI from "../UI/UI.js";

export default class Sizes extends EventEmitter {

    static _instance = null

    static getInstance() {
        return Sizes._instance || new Sizes()
    }

    constructor() {
        // Singleton
        if ( Sizes._instance ) {
            return Sizes._instance
        }

        super()

        Sizes._instance = this

        this.UI = UI.getInstance()

        // Setup
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min( window.devicePixelRatio, 2 )

        this.hero = {};

        this.hero.height = this.UI.html.hero.clientHeight
        this.hero.width = this.UI.html.hero.clientWidth
        this.hero.wrapperRect = this.UI.html.hero.getBoundingClientRect()

        this.isMobile = this.getIsMobile()

        // Resize event
        window.addEventListener( 'resize', () => {
            this.width = window.innerWidth
            this.height = window.innerHeight
            this.pixelRatio = Math.min( window.devicePixelRatio, 2 )

            this.hero.height = this.UI.html.hero.clientHeight
            this.hero.width = this.UI.html.hero.clientWidth
            this.hero.wrapperRect = this.UI.html.hero.getBoundingClientRect()
            this.isMobile = this.getIsMobile()

            this.trigger( 'resize' )
        } )
    }

    getIsMobile() {
        return window.matchMedia("(max-width: 767px)").matches
    }

}
